import { api } from ".";

// Define the response type for metrics data
interface IMetricsResponse {
  iframeUrl: string;
}

// Create metrics query endpoints
const metricsQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getCompanyDashboardUrl: builder.query<IMetricsResponse, void>({
      query: () => "metrics/company-dashboard",
    }),
  }),
});

export const { useGetCompanyDashboardUrlQuery } = metricsQueries;
